module.exports = __webpack_public_path__ + "static/media/Onlyafool.1229df61.png";